import React, { useEffect, useState, useMemo } from "react";
import {
  Segment,
  Tab,
  TabPane,
  Header,
  Grid,
  GridColumn,
  Table,
  Dropdown,
  Confirm,
  Icon,
} from "semantic-ui-react";
import { Line } from "@ant-design/charts";
import { Pie, Column , DualAxes} from "@ant-design/plots";
import { Link, useLocation } from "react-router-dom";
import { Permission, /* Form, Productionform, Socialform */ } from "../../../../api";
import { useAuth } from "../../../../hooks";
//import "./Dashboard.scss";
import { useLanguage } from "../../../../contexts/LanguageContext";
import { BasicModal, LoadingSpinner } from "../../../Shared";

import {
  socialKPIsCodes,
  socialFormulasIndicators,
  determineSocialUnits,
  socialCodes,
} from "../../../../utils/dataAndFormulas/socialForms";

import {
  convertUnits,
  formatValue,
} from "../../../../utils/dataAndFormulas/convert";

const permissionController = new Permission();
// const socialController = new Socialform();
// const formController = new Form();
// const productionController = new Productionform();

export function EmissionsSummaryDashboard(props) {
  const { site } = props;
  const {
    user: { role },
    accessToken,
  } = useAuth();
  const { language, translations } = useLanguage();

  const t = (key) => translations[key] || key;

  const [permissionActive, setPermissionsActive] = useState([]);
  const [baseline, setbaseline] = useState("");
  const [valueBaseline, setValueBaseline] = useState({});
  const [indicatorsLineBase, setIndicatorsLineBase] = useState([]);
  const [data, setData] = useState([]);
  const [totales, setTotales] = useState({});
  const [conceptos, setConceptos] = useState([]);

  const [loadingCount, setLoadingCount] = useState(0);
  const isLoading = loadingCount > 0;
  const [lastYears, setLastYears] = useState({}); // resultados calculados
    const [totalesByFilters, setTotalesByFilters] = useState({}); // resultados calculados

  const startLoading = () => setLoadingCount((prev) => prev + 1);
  const stopLoading = () => setLoadingCount((prev) => Math.max(prev - 1, 0));


  //declaración estado de filtros
  const [filters, setFilters] = useState({
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1,
  });
  
  useEffect(() => {
    (async () => {
      startLoading();
      try {
        setPermissionsActive([]);
        if (role) {
          const response = await permissionController.getPermissionsByRole(
            accessToken,
            role._id,
            true
          );
          setPermissionsActive(response);
        }
      } catch (error) {
        socialKPIsCodes.error(error);
        setPermissionsActive([]);
      } finally {
        stopLoading();
      }
    })();
  }, []);

  useEffect(() => {
    (async () => {
      startLoading();
      try {
        setData([]);
        if (site) {
          const prueba = await socialController.getSocialFormsByLineBaseYears(
            accessToken,
            site
          );

          setIndicatorsLineBase(prueba.socialForms.indicators);
          const yearsLineaBase = prueba.socialForms.years;
          const currentYear = new Date().getFullYear();

          const yearsUltimos5 = [
            currentYear,
            currentYear - 1,
            currentYear - 2,
            currentYear - 3,
            currentYear - 4,
          ].map(String);

          const añosCombinados = [...new Set([...yearsLineaBase, ...yearsUltimos5])];
          const response = await socialController.getSocialFormsByLastYears(
            accessToken,
            site,
            añosCombinados
          );

          setData(response.socialForms);
        }
      } catch (error) {
        setData([]);
      } finally {
        stopLoading();
      }
    })();
  }, [site]);

  useEffect(() => {
    (async () => {
      startLoading();
      setbaseline("");
      try {
        if (site) {
          const response = await formController.getLastBaselineByFormBySite(
            accessToken,
            site,
            "production"
          );

          if (response.code === 200) {
            setbaseline(response.baseline);

            const resultado = await Promise.all(
              Object.entries(response.baseline)
                .filter(([anio, valor]) => valor !== null)
                .map(async ([anio, valor]) => {
                  let a = await getValueBaseLine(anio, valor);
                  return { [anio]: a };
                })
            );

            const resultadoFinal = resultado.reduce((acc, obj) => {
              return { ...acc, ...obj };
            }, {});

            setValueBaseline(resultadoFinal);
          }
        }
      } catch (error) {
        console.error(error);
      } finally {
        stopLoading();
      }
    })();
  }, [site]);

  useEffect(() => {
    (async () => {
      startLoading();
      try {
        const previous_totals = await transformData1(data);
        await calculateDataFinal(previous_totals);
      } catch (error) {
        console.error(error);
      } finally {
        stopLoading();
      }
    })();
  }, [data]);

  const getValueBaseLine = async (year, type) => {
    try {
      const mode =
        type === "VPS" ? "standardized_production" : "standardized_billing";
      const response1 =
        await productionController.getTotalBaselineByYearAndSite(
          accessToken,
          site,
          year,
          mode
        );
      return response1.total;
    } catch (error) {
      return 1;
    }
  };
/*
  const determineFieldsKPIs = () => {
    return Object.keys(socialKPIsCodes);
  };

  const determineFieldsCode = () => {
    return Object.keys(socialCodes);
  };
*/

// Determinar los campos únicos de indicadores y si tienen código
    const determineFieldsKPIs = () => {
    const fields = new Set();
    console.log("🧠 conceptKeys:", conceptos);
    console.log("🧠 typeof conceptKeys:", typeof conceptos);

    Object.keys(energyKPIsCodes).forEach((key) => {
      fields.add(key);
    });

    return Array.from(fields);
  };

  // Determinar los campos únicos de los formularios y si tienen código
  const determineFieldsCode = () => {
    const fields = new Set();
    console.log("🧠 conceptKeys:", conceptos);
    console.log("🧠 typeof conceptKeys:", typeof conceptos);
    Object.keys(energyCodes).forEach((key) => {
      fields.add(key);
    });

    return Array.from(fields);
  };

  const transformData1 = async (data) => {
    const totalsPerYear = {};
    const conceptsSet = [];
    const unitsCache = {};
    const fields = determineFieldsCode();

    if (!data || !Array.isArray(data.data) || data.data.length === 0) {
      return {};
    }

    const uniqueYears = [...new Set(data.data.map((item) => String(item.year)))];

    await Promise.all(
      uniqueYears.map(async (año) => {
        try {
          const units = await socialController.getLastUnitFieldsByYear(
            accessToken,
            site,
            año,
            fields
          );
          if (units && units.fields) {
            unitsCache[año] = units;
          }
        } catch (error) {}
      })
    );

    const consumptionPromises = data.data.map(async (item) => {
      const year = String(item.year);
      const units = unitsCache[year];
      if (!units) return;

      fields.forEach((concept) => {
        if (item[concept]) {
          conceptsSet.push(concept);
          if (!totalsPerYear[concept]) totalsPerYear[concept] = {};
          if (!totalsPerYear[concept][year]) {
            totalsPerYear[concept][year] = {
              total: 0,
              count: 0,
              unit: units.fields[concept] || item[concept]?.unit || "",
            };
          }

          const value = item[concept].value
            ? convertUnits(
                item[concept].value,
                item[concept].unit,
                totalsPerYear[concept][year].unit
              )
            : 0;

          totalsPerYear[concept][year].total += value;
          totalsPerYear[concept][year].count += 1;
        }
      });
    });

    await Promise.all(consumptionPromises);

    Object.keys(totalsPerYear).forEach((concept) => {
      Object.keys(totalsPerYear[concept]).forEach((year) => {
        const { total, count } = totalsPerYear[concept][year];
        if (count > 0) {
          totalsPerYear[concept][year].average = total / count;
        }
      });
    });

    return totalsPerYear;
  };

  const calculateDataFinal = async (totales) => {
    const totalesFinal = { ...totales };
    const conceptsSet = [];

    if (totales !== undefined) {
      for (let item in totales) {
        if (totales.hasOwnProperty(item)) {
          for (let year in totales[item]) {
            const valueB = valueBaseline[year];
            if (totales[item].hasOwnProperty(year)) {
              const fields = determineFieldsKPIs();

              fields.forEach((concept) => {
                if (!totalesFinal[concept]) {
                  totalesFinal[concept] = {};
                  conceptsSet.push(concept);
                }

                if (!totalesFinal[concept][year]) {
                  totalesFinal[concept][year] = {};
                }

                totalesFinal[concept][year] = socialFormulasIndicators(
                  concept,
                  year,
                  totalesFinal,
                  valueB === 0 ? 1 : valueB
                );
              });
            }
          }
        }
      }
    }

    setConceptos(conceptsSet);
    setTotales(totalesFinal);
  };

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (
    !data ||
    !data.years ||
    data.years.length === 0 ||
    !conceptos ||
    conceptos.length === 0
  ) {
    return (
      <div style={{ textAlign: "center", padding: "5em 0", color: "#777" }}>
        <div style={{ fontSize: "2em", marginBottom: "1em", color: "#ccc" }}>
          <Icon name="exclamation triangle" size="huge" color="gray" />
        </div>
        <div
          style={{ fontSize: "1.5em", fontWeight: "bold", marginBottom: "1em" }}
        >
          {t("no_data_available") || "No hay datos disponibles"}
        </div>
      </div>
    );
  }

  return (
    <div className="list-social-forms">
      <TableGraf />
      <TableYears
        data={data}
        accessToken={accessToken}
        t={t}
        conceptos={conceptos}
        totales={totales}
        language={language}
        indicatorsLineBase={indicatorsLineBase}
      />
    </div>
  );
}


function TableYears(props) {
  const { data, conceptos, totales, t, language, indicatorsLineBase } = props;

  const [years, setYears] = useState([]);
  //const [listConceptos, setListConceptos] = useState([]);
  const [listConceptos, setListConceptos] = useState([]);

  //const [uniqueFields, setUniqueFields] = useState([]);
  const [selectedUnits, setSelectedUnits] = useState([]);

  const handleUnitChange = (rowIndex, newValue) => {
    setSelectedUnits({ ...selectedUnits, [rowIndex]: newValue.value });
  };

  useEffect(() => {
    (async () => {
      try {
        setYears(data.years ? data.years.sort((a, b) => b - a) : []);
      } catch (error) {
        // console.error(error);
      }
    })();
  }, [data]);

  useEffect(() => {
    (async () => {
      try {
        setListConceptos(conceptos);
      } catch (error) {
        // console.error(error);
      }
    })();
  },// [conceptos, setListConceptos]); //
      [conceptos]);

 // Función para obtener el icono de aumento o disminución
  const getIndicators = (item) => {
    let result = indicatorsLineBase.find((value) => value.name === item);
    if (result) {
      return result?.yearBaseline || 0;
    }
    return 0; // Sin cambio
  };

  function showWithTwoDecimals(numero) {
    // Verificamos si el parámetro es un número
    if (typeof numero !== "number" || isNaN(numero)) {
      // Si el valor no es un número, simplemente retornamos el valor tal como está.
      return numero;
    }

    // Si el número es entero, lo mostramos como entero.
    if (numero % 1 === 0) {
      return numero.toString(); // Muestra el número como cadena sin decimales.
    } else {
      // Si el número tiene decimales, lo mostramos con hasta 4 decimales
      // Usamos toFixed(2) para asegurar que no haya más de 4 decimales, pero luego
      // eliminamos los ceros innecesarios.
      let numeroConCuatroDecimales = numero.toFixed(2);

      // Eliminamos los ceros a la derecha si los hay
      return parseFloat(numeroConCuatroDecimales).toString();
    }
  }

  return (
    <>
      <Table celled structured size="small">
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell rowSpan="2" textAlign="center">
              {t("code")}
            </Table.HeaderCell>
            <Table.HeaderCell rowSpan="2" textAlign="center">
              {t("indicators")}
            </Table.HeaderCell>
            {years.map((year, index) => (
              <Table.HeaderCell rowSpan="2" textAlign="center" key={index}>
                {year}
              </Table.HeaderCell>
            ))}
            <Table.HeaderCell rowSpan="2" textAlign="center">
              {t("LB")}
            </Table.HeaderCell>
            <Table.HeaderCell
              rowSpan="2"
              textAlign="center"
              style={{ width: "200px" }}
            >
              {t("units")}
            </Table.HeaderCell>
            <Table.HeaderCell rowSpan="2" textAlign="center">
              {t("MWh equivalentes")}
            </Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {conceptos.map((item, index) => (
            <React.Fragment key={index}>
              <Table.Row>
                <Table.Cell>{eKPIsCodes[item]}</Table.Cell>
                <Table.Cell>{t(item)}</Table.Cell>
                {years.map((year, i) => {
                  if (totales[item]) {
                    const currentValue = totales[item][year]?.total || 0;
                    const previousValue = totales[item][year - 1]?.total
                      ? totales[item][year - 1]?.total
                      : 0; // Compara con el año anterior
                    return (
                      <Table.Cell key={i}>
                        {formatValue(
                          showWithTwoDecimals(
                            convertUnits(
                              totales[item][year]?.total || 0,
                              totales[item][year]?.unit,
                              selectedUnits[item],
                              selectedUnits
                            )
                          ),
                          language
                        )}{" "}
                        {i >= 0 &&
                          getComparativeIcon(currentValue, previousValue)}
                      </Table.Cell>
                    );
                  }
                  return <Table.Cell key={i}>{""}</Table.Cell>;
                })}
                <Table.Cell>
                  {showWithTwoDecimals(
                    totales[item][getIndicators(item)]?.total
                  ) || 0}
                </Table.Cell>
                <Table.Cell>
                  {
                    <Dropdown
                      onChange={(e, data) => {
                        handleUnitChange(item, data);
                      }}
                      options={determineEmissionsUnits(item).map((ds) => {
                        return {
                          key: ds.key,
                          text: ds.name,
                          value: ds.value,
                        };
                      })}
                      search
                      inline
                      defaultValue={determineEmissionsUnits(item)[0].value}
                      //value={filter}
                    />
                  }
                </Table.Cell>

                <Table.Cell>
                  {/* {" "}
                  {convertUnitsFinal(
                    totales[item][getIndicators(item)]?.total || 0,
                    totales[item][getIndicators(item)]?.unit,
                    "MWh",
                    item
                  ) || 0} */}
                </Table.Cell>
              </Table.Row>
            </React.Fragment>
          ))}
        </Table.Body>
      </Table>
    </>
  );
}

export const YearMonthSelector = ({ onChange }) => {
  const currentYear = new Date().getFullYear();

  const years = [
    { key: currentYear, text: currentYear, value: currentYear },
    { key: currentYear - 1, text: currentYear - 1, value: currentYear - 1 },
    { key: currentYear - 2, text: currentYear - 2, value: currentYear - 2 },
    { key: currentYear - 3, text: currentYear - 3, value: currentYear - 3 },
  ];

  const months = [
    { key: 1, text: "Enero", value: 1 },
    { key: 2, text: "Febrero", value: 2 },
    { key: 3, text: "Marzo", value: 3 },
    { key: 4, text: "Abril", value: 4 },
    { key: 5, text: "Mayo", value: 5 },
    { key: 6, text: "Junio", value: 6 },
    { key: 7, text: "Julio", value: 7 },
    { key: 8, text: "Agosto", value: 8 },
    { key: 9, text: "Septiembre", value: 9 },
    { key: 10, text: "Octubre", value: 10 },
    { key: 11, text: "Noviembre", value: 11 },
    { key: 12, text: "Diciembre", value: 12 },
  ];

  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1); // 1-12

  const handleYearChange = (e, { value }) => {
    setSelectedYear(value);
    onChange({ year: value, month: selectedMonth });
  };

  const handleMonthChange = (e, { value }) => {
    setSelectedMonth(value);
    onChange({ year: selectedYear, month: value });
  };

  return (
    <div style={{ display: "flex", gap: "10px", marginBottom: "20px" }}>
      <Dropdown
        placeholder="Año"
        selection
        options={years}
        value={selectedYear}
        onChange={handleYearChange}
      />
      <Dropdown
        placeholder="Mes"
        selection
        options={months}
        value={selectedMonth}
        onChange={handleMonthChange}
      />
    </div>
  );
};

function EmissionsComparisonChart({ resultsByYear }) {
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const monthMap = {
    January: "Enero",
    February: "Febrero",
    March: "Marzo",
    April: "Abril",
    May: "Mayo",
    June: "Junio",
    July: "Julio",
    August: "Agosto",
    September: "Septiembre",
    October: "Octubre",
    November: "Noviembre",
    December: "Diciembre",
  };

  const years = Object.keys(resultsByYear);

  // // Datos de barras
  // const barData = [];
  // years.forEach((year) => {
  //   months.forEach((month) => {
  //     const total =
  //       resultsByYear?.[year]?.[month]?.total_energy_month?.total || 0;
  //     barData.push({
  //       year: String(year),
  //       month, // ⚠ mantener en inglés para agrupar correctamente
  //       value: total,
  //     });
  //   });
  // });

  // // Datos de línea de promedio por año
  // const lineData = [];
  // years.forEach((year) => {
  //   const values = months.map(
  //     (month) => resultsByYear?.[year]?.[month]?.total_energy_month?.total || 0
  //   );
  //   const avg = values.reduce((a, b) => a + b, 0) / values.length;
  //   months.forEach((month) => {
  //     lineData.push({
  //       year: String(year),
  //       month,
  //       value: avg,
  //     });
  //   });
  // });

    // ✅ Calcular los datos solo cuando cambien resultsByYear
  const { barData, lineData } = useMemo(() => {
    const bar = [];
    const line = [];

    years.forEach((year) => {
      const values = months.map(
        (month) => resultsByYear?.[year]?.[month]?.total_emissions_month?.total || 0
      );

      const avg = values.reduce((a, b) => a + b, 0) / values.length;

      months.forEach((month, i) => {
        const total = values[i];
        bar.push({
          year: String(year),
          month,
          value: total,
        });
        line.push({
          year: String(year),
          month,
          value: avg,
        });
      });
    });

    return { barData: bar, lineData: line };
  }, [resultsByYear]); // 👈 solo recalcula si cambian los datos

  const config = {
    xField: "month",
    legend: true,
    children: [
      {
        data: barData,
        type: "interval",
        // xField: "month",
        yField: "value",
        colorField: "year",
        seriesField: "year", // 🔹 esto separa las barras por año
        group: true,
        // style: { maxWidth: 80 },
        interaction: { elementHighlight: { background: true } },
      },
      {
        data: lineData,
        type: "line",
        yField: "value",
        // xField: "month",
        colorField: "year",
        smooth: true,
        lineStyle: { lineWidth: 2, lineDash: [4, 4] },
        axis: { y: { position: "right" } },
      },
    ],
    tooltip: { shared: true },
    height: 300,
    legend: { position: "top" },
    xAxis: {
      label: {
        formatter: (val) => t(val) || val, // 🔹 mostrar meses en español
      },
    },
  };

  return (
    <div style={{ height: 350, marginTop: 20, marginBottom: 20 }}>
      <h3 className="text-lg font-semibold mb-2 text-center">
        🔋 Consumo energético comparativo — Últimos 3 años
      </h3>
      <DualAxes {...config} />
    </div>
  );
}

function EnergyMonthlyChart({ resultsByYear }) {

  console.log(resultsByYear)
  const months = [
    "January","February","March","April","May","June",
    "July","August","September","October","November","December",
  ];

  const monthMap = {
    January: "Enero", February: "Febrero", March: "Marzo", April: "Abril",
    May: "Mayo", June: "Junio", July: "Julio", August: "Agosto",
    September: "Septiembre", October: "Octubre",
    November: "Noviembre", December: "Diciembre",
  };

  const years = Object.keys(resultsByYear);

  // 🔹 Paleta de colores fija por año
  const yearColors = {
    2023: '#5B8FF9', // azul
    2024: '#34D399', // verde
    2025: '#F6BD16', // amarillo
    2026: '#EF4444', // rojo
  };

    // ✅ useMemo garantiza nueva referencia cuando cambia resultsByYear
  const { consumptionData, averageData } = useMemo(() => {
    const cData = [];
    const aData = [];

    years.forEach((year) => {
      const totals = months.map(
        (m) => resultsByYear?.[year]?.[m]?.total_energy_month?.total || 0
      );
      const avg = totals.reduce((a, b) => a + b, 0) / totals.length;

      months.forEach((month, i) => {
        const total = totals[i];
        cData.push({
          year,
          month: monthMap[month],
          value: total,
          type: 'Consumo',
        });
        aData.push({
          year,
          month: monthMap[month],
          value: avg,
          type: 'Promedio',
        });
      });
    });

    return { consumptionData: cData, averageData: aData };
  }, [resultsByYear]); // 👈 se recalcula solo cuando cambian los datos

  // 🔹 Config del gráfico
  const config = {
    xField: 'month',
        scale: {
      color: {
        // 👇 Colores por año (en orden)
        range: ['#5B8FF9', '#5AD8A6', '#5D7092', '#F6BD16', '#6F5EF9'],
      },
    },
    children: [
      // Línea sólida (consumo)
      {
        data: consumptionData,
        type: 'line',
        yField: 'value',
        colorField: 'year',
        shapeField: 'smooth',
        style: ({ year }) => ({
          lineWidth: 3,
          stroke: yearColors[year] || '#999999',
        }),
      },
      // Línea punteada (average)
      {
        data: averageData,
        type: 'line',
        yField: 'value',
        colorField: 'year',
        shapeField: 'smooth',
        style: ({ year }) => ({
          lineWidth: 2,
          lineDash: [6, 4],
          stroke: yearColors[year] || '#999999',
        }),
      },
    ],
    xAxis: {
      label: { formatter: (val) => monthMap[val] || val },
    },
    legend: {
      position: 'top',
      itemName: {
        formatter: (text, item) => `Año ${item.value}`,
      },
    },
    tooltip: { shared: true },
    height: 400,
  };

  return (
    <div style={{ height: 450, marginTop: 20, marginBottom: 20 }}>
      <h3 className="text-lg font-semibold mb-2 text-center">
        ⚡ Consumo mensual de Energía Eléctrica / Producción
      </h3>
      <DualAxes {...config} />
    </div>
  );
}


 /* // Función para obtener el icono de aumento o disminución
  const getComparativeIcon = (currentYear, previousYear) => {
    if (previousYear !== null) {
      if (currentYear > previousYear) {
        return <Icon disabled name="angle up" color="green" />; // Aumento
      } else if (currentYear < previousYear) {
        return <Icon disabled name="angle down" color="red" />; // Disminución
      } else if (currentYear === previousYear) {
        //return <Icon disabled name="sync" color="blue" />; // Disminución
        return <span style={{ color: "blue", fontWeight: "bold" }}>=</span>;
      }
    }
    return null; // Sin cambio
  };

  useEffect(() => {
    (async () => {
      try {
        // Obtener todos los campos únicos

        let valor = {};
        conceptos.map(
          (field) => (valor[field] = obtenerUnidadMasUsada(totales, field))
        );

        setSelectedUnits(valor);
      } catch (error) {
        // console.error(error);
        setSelectedUnits([]);
      }
    })();
  }, [totales]);

  const obtenerUnidadMasUsada = (datos, concepto) => {
    const años = Object.keys(datos[concepto]);
    const unidades = {};

    // Contamos las unidades de cada año, ignorando las unidades vacías o no definidas
    años.forEach((año) => {
      const unidad = datos[concepto][año]?.unit || false;

      // Si la unidad es vacía o no existe, la ignoramos
      if (unidad && unidad !== "") {
        unidades[unidad] = (unidades[unidad] || 0) + 1;
      }
    });

    // Si no se encontraron unidades válidas, devolvemos la unidad del último año
    if (Object.keys(unidades).length === 0) {
      return datos[concepto][años[años.length - 1]]?.unit || "";
    }

    // Ordenamos las unidades por frecuencia (de mayor a menor)
    const unidadesOrdenadas = Object.entries(unidades).sort(
      (a, b) => b[1] - a[1]
    );

    // Si hay un empate (varias unidades con la misma frecuencia), seleccionamos la del último año
    if (
      unidadesOrdenadas.length > 1 &&
      unidadesOrdenadas[0][1] === unidadesOrdenadas[1][1]
    ) {
      // Si hay empate, tomamos la unidad del último año
      return datos[concepto][años[años.length - 1]].unit;
    }

    // Si no hay empate, tomamos la unidad más frecuente
    return unidadesOrdenadas[0][0];
  };

  const getIndicators = (item) => {
    let result = indicatorsLineBase.find((value) => value.name === item);
    if (result) {
      return result?.yearBaseline || 0;
    }
    return 0; // Sin cambio
  };

  function showWithTwoDecimals(numero) {
    // Verificamos si el parámetro es un número
    if (typeof numero !== "number" || isNaN(numero)) {
      // Si el valor no es un número, simplemente retornamos el valor tal como está.
      return numero;
    }

    // Si el número es entero, lo mostramos como entero.
    if (numero % 1 === 0) {
      return numero.toString(); // Muestra el número como cadena sin decimales.
    } else {
      // Si el número tiene decimales, lo mostramos con hasta 4 decimales
      // Usamos toFixed(2) para asegurar que no haya más de 4 decimales, pero luego
      // eliminamos los ceros innecesarios.
      let numeroConCuatroDecimales = numero.toFixed(2);

      // Eliminamos los ceros a la derecha si los hay
      return parseFloat(numeroConCuatroDecimales).toString();
    }
  }
    //const years = [2023, 2022, 2021, 2020, 2019];
  const baselineYear = "Linea base";

  const indicadores = [
    { label: "Alcance 1 - Directa", subItems: ["Combustible vehículos", "Combustible operaciones"] },
    { label: "Alcance 2 – Indirecta", subItems: ["Electricidad"] },
    { label: "Total Alcance 1&2", subItems: [] },
  ];

  const getValue = (indicator, year) => {
    return data[indicator]?.[year] ?? "";
  };

  const getPercentChange = (indicator, year1, year2) => {
    const val1 = data[indicator]?.[year1] ?? 0;
    const val2 = data[indicator]?.[year2] ?? 0;
    if (!val2) return "-";
    const change = ((val1 - val2) / val2) * 100;
    return `${change.toFixed(2)}%`;
  };

  return (
    <>
      <Header as="h3" textAlign="center">
        Alcance 1 y 2 CO₂e (EMISIONES GEI) – NOMBRE DE LA EMPRESA
      </Header>

      <Table celled structured size="small">
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell rowSpan="2" textAlign="center">
              Emisiones CO₂e s1-8 (t)
            </Table.HeaderCell>
            {years.map((year) => (
              <Table.HeaderCell key={year} textAlign="center">
                {year}
              </Table.HeaderCell>
            ))}
            <Table.HeaderCell textAlign="center">{baselineYear}</Table.HeaderCell>
            <Table.HeaderCell textAlign="center">% Cambio 2023/2022</Table.HeaderCell>
            <Table.HeaderCell textAlign="center">% Cambio 2023/2017</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {indicadores.map((grupo, i) => (
            <React.Fragment key={i}>
              <Table.Row>
                <Table.Cell colSpan={years.length + 4}>
                  <strong>{grupo.label}</strong>
                </Table.Cell>
              </Table.Row>
              {grupo.subItems.length > 0
                ? grupo.subItems.map((sub, idx) => (
                    <Table.Row key={idx}>
                      <Table.Cell>{sub}</Table.Cell>
                      {years.map((year) => (
                        <Table.Cell key={year} textAlign="right">
                          {getValue(sub, year)}
                        </Table.Cell>
                      ))}
                      <Table.Cell textAlign="right">
                        {getValue(sub, baselineYear)}
                      </Table.Cell>
                      <Table.Cell textAlign="right">
                        {getPercentChange(sub, 2023, 2022)}
                      </Table.Cell>
                      <Table.Cell textAlign="right">
                        {getPercentChange(sub, 2023, 2017)}
                      </Table.Cell>
                    </Table.Row>
                  ))
                : (
                    <Table.Row>
                      <Table.Cell>{grupo.label}</Table.Cell>
                      {years.map((year) => (
                        <Table.Cell key={year} textAlign="right">
                          {getValue(grupo.label, year)}
                        </Table.Cell>
                      ))}
                      <Table.Cell textAlign="right">
                        {getValue(grupo.label, baselineYear)}
                      </Table.Cell>
                      <Table.Cell textAlign="right">
                        {getPercentChange(grupo.label, 2023, 2022)}
                      </Table.Cell>
                      <Table.Cell textAlign="right">
                        {getPercentChange(grupo.label, 2023, 2017)}
                      </Table.Cell>
                    </Table.Row>
                  )}
            </React.Fragment>
          ))}
        </Table.Body>
      </Table>
    </>
  );
}
/*
function TableGraf(props) {
  const data2 = [
    { type: "2025", value: 0.16 },
    { type: "2024", value: 0.125 },
  ];

  const config3 = {
    data: [
      { type: "2025", value: 3 },
      { type: "2024", value: 4 },
      { type: "2023", value: 3.5 },
    ],
    angleField: "value",
    colorField: "type",
    innerRadius: 0.6,
    label: {
      text: "value",
      style: {
        fontWeight: "bold",
      },
    },
    legend: {
      color: {
        title: false,
        position: "right",
        rowPadding: 5,
      },
    },
    // annotations: [
    //   {
    //     type: 'text',
    //     style: {
    //       text: '',
    //       x: '50%',
    //       y: '50%',
    //       textAlign: 'center',
    //       fontSize: 40,
    //       fontStyle: 'bold',
    //     },
    //   },
    // ],
  };

  const config = {
    data: data2,
    xField: "type",
    yField: "value",
    style: {
      fill: ({ type }) => {
        if (type === "10-30分" || type === "30+分") {
          return "#22CBCC";
        }
        return "#2989FF";
      },
      maxWidth: 60,
    },
    label: {
      text: (originData) => {
        const val = parseFloat(originData.value);
        if (val < 0.05) {
          return (val * 100).toFixed(1) + "%";
        }
        return "";
      },
      offset: 10,
    },
    legend: false,
    responsive: true, // Asegura que sea responsivo
  };
  return (
    <div>
      <Table celled size="small">
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>TOTAL CO2e</Table.HeaderCell>
            <Table.HeaderCell>
              Alcance 1 CO2e{" "}
            </Table.HeaderCell>
            <Table.HeaderCell>
              Alcance 2 CO2e{" "}
            </Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          <Table.Row>
            <Table.HeaderCell  textAlign='center'>Alcance 1 y 2</Table.HeaderCell>
            <Table.HeaderCell textAlign='center' >
              Emisiones por fuente y alcance{" "}
            </Table.HeaderCell>
            <Table.HeaderCell textAlign='center'>
              Emisiones totales vs linea base{" "}
            </Table.HeaderCell>
          </Table.Row>
        </Table.Body>

        <Table.Body>
          <React.Fragment>
            {/* Fila para el título y los valores */
       /*     <Table.Row>
              <Table.Cell style={{ width: "35%" }}>
                {" "}
                <div style={{ width: "100%", height: 300 }}>
                  <Pie {...config3} />
                </div>
              </Table.Cell>
              <Table.Cell style={{ width: "30%" }}>
                <div style={{ width: "80%", height: 300 }}>
                  <Column {...config} />
                </div>
              </Table.Cell>
              <Table.Cell style={{ width: "35%" }}>
                {" "}
                <div style={{ width: "100%", height: 300 }}>
                  <Pie {...config3} />
                </div>
              </Table.Cell>{" "}
              {/* Esta celda está vacía en la fila del título */
           /* </Table.Row>
          </React.Fragment>
        </Table.Body>
      </Table>
    </div>
  );
}
*/